// Shared input filter helpers for controlled inputs.
export function filterLetters(value) {
  return String(value || '').replace(/[^a-zA-Z .-]/g, '');
}

export function filterDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

export function filterPhone(value) {
  const raw = String(value || '');
  const cleaned = raw.replace(/[^0-9+]/g, '');
  if (!cleaned) return '';
  const hasPlus = cleaned[0] === '+';
  const digits = cleaned.replace(/\D/g, '');
  return hasPlus ? `+${digits}` : digits;
}

export function filterDateString(value) {
  return String(value || '').replace(/[^0-9-]/g, '');
}

const isModifierCombo = (e) => {
  if (!(e.ctrlKey || e.metaKey)) return false;
  const key = e.key.toLowerCase();
  return key === 'a' || key === 'c' || key === 'v' || key === 'x' || key === 'z';
};

const isNavKey = (key) => (
  key === 'Backspace' ||
  key === 'Delete' ||
  key === 'Tab' ||
  key === 'Enter' ||
  key === 'ArrowLeft' ||
  key === 'ArrowRight' ||
  key === 'ArrowUp' ||
  key === 'ArrowDown' ||
  key === 'Home' ||
  key === 'End'
);

export function lettersKeyDown(e) {
  if (isModifierCombo(e) || isNavKey(e.key)) return;
  if (/^[a-zA-Z .-]$/.test(e.key)) return;
  e.preventDefault();
}

export function digitsKeyDown(e) {
  if (isModifierCombo(e) || isNavKey(e.key)) return;
  if (/^[0-9]$/.test(e.key)) return;
  e.preventDefault();
}

export function phoneKeyDown(e, currentValue) {
  if (isModifierCombo(e) || isNavKey(e.key)) return;
  if (/^[0-9]$/.test(e.key)) return;
  if (e.key === '+') {
    const val = String(currentValue || '');
    if (val.length === 0 && !val.includes('+')) return;
  }
  e.preventDefault();
}
